import React, { useEffect, useState } from 'react'
import year from "../../images/yeear.svg";
import engineSize from "../../images/engine.svg";
import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import calendar from "../../images/calendar.svg";
import { handleCarClick, handleRealEstateClick } from "../../methods/handlers";
import { ClipLoader } from 'react-spinners'
import { regions } from "../../utils/regions";
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import apiClient from '../../utils/apiClient';
import strings from '../../utils/locals/languages';


const RegionAds = () => {

    const user = Cookies.get("userDetails");

    const navigate = useNavigate();
    const [userId, setUserId] = useState("");
    const [selectedCityData, setSelectedCityData] = useState([])
    const [selectedCity, setSelectedCity] = useState("")
    const [citiesLoading, setCitiesLoading] = useState(false)


    const getCities = async (region) => {
        setSelectedCity(region)
        try {
            const response = await apiClient.get(`/v1/adds/region-ads?region=${region.value}&language=${strings._language}`);

            setSelectedCityData(response.data.ads)
            setCitiesLoading(false)

        } catch (error) {
            setCitiesLoading(false)
        }
    };
    const addToFavorites = async (event, adId) => {
        event.stopPropagation();
        try {
            await apiClient.get(`/v1/user/fav-unfav/${adId}`);

            await getCities(selectedCity)
        } catch (error) {
            console.error("Error updating favorites:", error);
        }
    };

    useEffect(() => {
        const userDetails = Cookies.get("userDetails");

        if (userDetails) {
            const user = JSON?.parse(userDetails);
            setUserId(user._id);
        } else {
            setUserId("0");
        }
    }, []);

    return (
        <>
            <div className="container">
                <h4 className="uppercase mt-4 text-[20px] font-semibold">
                    {strings.topCities}
                </h4>
                <div className="flex overflow-x-auto gap-4 mt-4 ">
                    {regions[strings._language]?.map((region, index) => (
                        <div
                            key={index}
                            className="relative flex-shrink-0 w-[300px] h-[300px] cursor-pointer rounded-lg overflow-hidden"
                            onClick={() => {
                                setCitiesLoading(true)
                                getCities(region)
                            }}
                        >
                            <img
                                className="w-full h-full object-cover"
                                src={region.image}
                                alt={region.title}
                            />

                            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>

                            <div className="absolute bottom-6 w-full text-center text-lg font-semibold text-white px-4">
                                {region.title}
                            </div>

                            <div className="absolute bottom-1 w-full text-center text-sm text-white opacity-80 px-4">
                            </div>
                        </div>
                    ))}
                </div>


            </div>


            {
                citiesLoading ? <div className="container flex items-center justify-center"> <ClipLoader />  </div> : (
                    selectedCityData.length !== 0 ? (
                        <div className="container">
                            <h3>{selectedCityData.length} Ads</h3>
                            <div className="grid grid-cols-1  md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 gap-3 justify-center">
                                {selectedCityData.map((item, index) => (
                                    <div
                                        className="c shadow-xl rounded-xl  cursor-pointer "

                                        onClick={() => {
                                            if (item.section === "638f25154cb7c29ec6ad4bfe") {
                                                handleRealEstateClick(navigate, item._id, item.basicInformation.title, item.basicInformation.category.category[0].title, item.basicInformation.brand.sub_category[0].title, item.location.city, item.location.district)

                                            } else {
                                                handleCarClick(navigate, item._id, item.basicInformation.title, item.basicInformation.title, item.basicInformation.category.category[0].title, item.basicInformation.brand.sub_category[0].title, item.basicInformation.model.model[0].title, item.location.city, item.location.district, item.basicInformation.KM)

                                            }
                                        }}

                                    >
                                        <div className="relative h-40">
                                            {!item?.fav.includes(userId) ? (
                                                <FavoriteBorderOutlinedIcon
                                                    className="absolute items-content-end w-12"
                                                    style={{
                                                        right: "8px",
                                                        color: "#F37521",
                                                        backgroundColor: "white",
                                                        borderRadius: 100,
                                                        padding: 3,
                                                        top: 8,
                                                    }}
                                                    onClick={(event) => {
                                                        if (user) {
                                                            event.stopPropagation()
                                                            addToFavorites(event, item._id);
                                                        }
                                                    }}
                                                />
                                            ) : (
                                                <FavoriteOutlinedIcon
                                                    className="absolute items-content-end w-12 opacity-100"
                                                    style={{
                                                        right: "8px",
                                                        color: "red",
                                                        backgroundColor: "white",
                                                        borderRadius: 100,
                                                        padding: 3,
                                                        top: 8,
                                                    }}
                                                    onClick={(event) => {
                                                        if (user) {
                                                            event.stopPropagation()
                                                            addToFavorites(event, item._id);
                                                        }
                                                    }}
                                                />
                                            )}
                                            <img
                                                className=" rounded-t-2xl"
                                                src={item.coverPhoto || item.imageUrl[0]}
                                                alt="random"
                                                style={{
                                                    height: "100%",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    // borderTopRightRadius: 12,
                                                    // borderTopLeftRadius: 12,
                                                }}
                                            />
                                        </div>
                                        <div className="px-[10px] mt-2">
                                            <div
                                                className="flex items-center justify-between"

                                            >
                                                <div>
                                                    <h3 className="font-[500] text-sm whitespace-nowrap overflow-hidden text-ellipsis max-w-full">
                                                        {item?.basicInformation?.title.length > 14
                                                            ? `${item.basicInformation.title.slice(0, 12)}...`
                                                            : item.basicInformation.title
                                                        }

                                                    </h3>
                                                </div>

                                                <div className="flex " style={{ color: "#F37521" }}>
                                                    <h1 className="font-bold text-sm ">
                                                        {item?.basicInformation?.price?.currency}&nbsp;
                                                    </h1>
                                                    <h1 className="font-bold text-sm ">
                                                        {Number(item?.basicInformation?.price?.price).toLocaleString(undefined, { maximumFractionDigits: 2 })}
                                                    </h1>
                                                </div>
                                            </div>
                                            <div className="flex gap-2 -mb-2">
                                                <h1 className="text-[9px] font-[350] text-gray-400 ">
                                                    {item?.basicInformation?.description?.slice(0, 25)}
                                                </h1>
                                            </div>
                                            <div
                                                className="flex -mb-1 text-[10px] justify-between items-center text-gray-400"

                                            >
                                                <div className="flex gap-2 items-center">
                                                    <img src={year} alt="year" className="h-3 w-3" />
                                                    <p className=" mt-[17px]">
                                                        {item?.basicInformation?.details[0]?.value}
                                                    </p>
                                                </div>

                                                <div className="flex gap-2 items-center">
                                                    <img
                                                        src={engineSize}
                                                        alt="year"
                                                        className="h-3 w-3"
                                                    />
                                                    <p className=" mt-[17px]">
                                                        {item?.basicInformation?.details
                                                            .filter((item) =>
                                                                [
                                                                    "Engine Size",
                                                                    "Размер двигателя",
                                                                    "Dvigatel hajmi",
                                                                ].includes(item?.fieldName)
                                                            )
                                                            .map((filteredItem, index) => (
                                                                <span key={index}>{filteredItem?.value}</span>
                                                            ))}
                                                    </p>
                                                </div>

                                                <div className="flex gap-2 items-center">
                                                    <img
                                                        src={calendar}
                                                        color="gray"
                                                        alt="year"
                                                        className="h-3 w-3 opacity-60"
                                                    />
                                                    <p className=" mt-[17px]">
                                                        {item?.basicInformation?.KM}{" "}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        
                    ) : (
                        selectedCity && (
                            <div className="container flex w-full justify-center font-bold">
                                {selectedCity.title}: {strings.noAdsFound}
                            </div>
                        )
                    )
                )
            }

        </>
    )
}

export default RegionAds